import React from 'react';
import { useSelector } from 'react-redux';
import ExportButton from '../exportButton.js';
import ExportCertificates from '../exportCertificates.js';
import { _ } from '../../../functions/translator.js';

function ExportTabs (props) {
    const userRole = useSelector(state => state.userRole)
    const visibleCardsGroupIds = useSelector(state => state.visibleCardsGroupIds)
    let hidden = true
    if(Array.isArray(props.index)) {
        if(props.index.includes(props.tabIndex)){
            hidden = false
        }
    } else {
        hidden = props.tabIndex !== props.index
    }
    return (
        <div
            role="tabpanel"
            hidden={hidden}
            className='mt-4'
        >
            <p className='m-0'>{_('Registros filtrados para descargar')}:</p>
            <div className='d-flex justify-content-center'><p className='m-0 mb-2'>{visibleCardsGroupIds?.length}</p></div>
            {userRole.project_dashboard && (
                <>
                    <ExportButton name={'Observaciones'} endpoint={'export-observations'} postData={'postDataBlob'} ext={'.xlsx'}></ExportButton>
                    <ExportButton name={'Registros'} endpoint={'export-cardsgroups'} postData={'postDataBlob'} ext={'.xlsx'}></ExportButton>
                    <ExportCertificates></ExportCertificates>
                </>
            )}
        </div>
    )
}

export default ExportTabs;